/**
 * Централизованные утилиты для работы с числами, деньгами и геометрией.
 * Предотвращают ошибки округления и дублирование кода парсинга.
 */

/**
 * Безопасно преобразует значение в число.
 * Поддерживает замену запятой на точку.
 */
export const parseSafeNumber = (value: unknown, defaultValue: number = 0): number => {
    if (value === null || value === undefined || value === '') return defaultValue;
    // WR-02: guard against Infinity/-Infinity as well as NaN — all are unsafe for financial calculations.
    // parseFloat("Infinity") returns Infinity which is not NaN, so the old isNaN guard missed it.
    if (typeof value === 'number') return isNaN(value) || !isFinite(value) ? defaultValue : value;
    
    const sanitized = String(value).replace(',', '.').replace(/[^\d.-]/g, '');
    const parsed = parseFloat(sanitized);
    
    return isNaN(parsed) ? defaultValue : parsed;
};

/**
 * Округляет число до заданного количества знаков.
 * Возвращает число (в отличие от native toFixed).
 */
export const roundTo = (value: number, decimals: number = 2): number => {
    const factor = Math.pow(10, decimals);
    return Math.round((value + Number.EPSILON) * factor) / factor;
};

/**
 * Форматирует число для отображения (деньги).
 */
export const formatMoney = (value: number): string => {
    return roundTo(value, 0).toLocaleString('ru-RU');
};

/**
 * Форматирует число для отображения (размеры/площадь).
 */
export const formatArea = (value: number): string => {
    return roundTo(value, 2).toLocaleString('ru-RU', { 
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 
    });
};
